import { render, staticRenderFns } from "./GiftedDepositYN.vue?vue&type=template&id=57e58d02"
import script from "./GiftedDepositYN.vue?vue&type=script&lang=js"
export * from "./GiftedDepositYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports